import React, { useState } from 'react';
import MobileFilterButton from '../SortSelect/MobileFilterButton';
import { ModalFilter } from './ModalFilter';
export var FilterMobile = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return !isOpen ? (React.createElement(MobileFilterButton, { setIsOpen: setIsOpen })) : (React.createElement(ModalFilter, { setIsOpen: setIsOpen }));
};
